var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-4",attrs:{"id":"languages"},on:{"keydown":_vm.handleFormActions,"click":function($event){return _vm.$emit('clicked')}}},_vm._l((_vm.languageList),function(lang,index){return _c('div',{key:lang.id,staticClass:"menu-element-container px-4 d-flex justify-content-between align-items-center focusable",attrs:{"id":lang.code,"tabindex":"-1"},on:{"click":function($event){_vm.formPos = index}}},[_c('p',{class:{
        'opacity-50':
          _vm.languageList[index].code !== _vm.userInfo.defaultUserLanguage.code &&
          _vm.languageList[_vm.formPos].code !== _vm.languageList[index].code
      }},[_vm._v(" "+_vm._s(lang.name)+" ")]),_c('CheckIcon',{class:{
        'opacity-50':
          _vm.languageList[index].code !== _vm.userInfo.defaultUserLanguage.code &&
          _vm.languageList[_vm.formPos].code !== _vm.languageList[index].code
      }})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }